import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "../context/CartContext";
import { eur } from "../config";

export const ProductCard = ({ product, index = 0 }) => {
  const { addItem, toggleWishlist, wishlist } = useCart();
  const liked = wishlist.includes(product.slug);
  const hasSizes = product.sizes && product.sizes.length > 0;
  const discount = product.old_price ? Math.round((1 - product.price / product.old_price) * 100) : 0;

  const quickAdd = (e) => {
    e.preventDefault();
    addItem(product, { size: hasSizes ? product.sizes[0] : null, color: product.colors?.[0] || null });
    toast.success(`${product.name} ajouté au panier`);
  };

  return (
    <Link to={`/produit/${product.slug}`} className="group block" data-testid={`product-card-${product.slug}`}>
      <div className="relative overflow-hidden bg-white hover-zoom aspect-[3/4]">
        <img src={product.images[0]} alt={product.name} loading="lazy" className="w-full h-full object-cover" />
        {product.images[1] && (
          <img src={product.images[1]} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        )}
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {product.is_new && <span className="bg-dore text-white text-[10px] px-2.5 py-1 uppercase tracking-wider">Nouveau</span>}
          {product.is_bestseller && <span className="bg-red-600 text-white text-[10px] px-2.5 py-1 uppercase tracking-wider">Best-Seller</span>}
          {discount > 0 && <span className="bg-encre text-white text-[10px] px-2.5 py-1 uppercase tracking-wider">-{discount}%</span>}
        </div>
        <button onClick={(e) => { e.preventDefault(); toggleWishlist(product.slug); }} data-testid={`wishlist-${product.slug}`}
          className="absolute top-3 right-3 bg-white/80 backdrop-blur p-2 rounded-full hover:bg-white transition-colors">
          <Heart size={16} className={liked ? "fill-rose text-rose" : "text-encre"} />
        </button>
        <button onClick={quickAdd} data-testid={`quick-add-${product.slug}`}
          className="absolute bottom-0 inset-x-0 bg-noir/90 text-white py-3 text-[11px] uppercase tracking-widest font-semibold translate-y-full group-hover:translate-y-0 transition-transform duration-300 flex items-center justify-center gap-2">
          <ShoppingBag size={14} /> Ajouter au panier
        </button>
        {product.stock < 5 && <span className="absolute bottom-3 left-3 group-hover:opacity-0 transition-opacity bg-white/90 text-encre text-[10px] px-2 py-1">Plus que {product.stock} en stock</span>}
      </div>
      <div className="pt-3 text-center">
        <h3 className="text-sm text-encre font-medium">{product.name}</h3>
        <div className="flex items-center justify-center gap-2 mt-1">
          <span className="text-dore font-display text-lg">{eur(product.price)}</span>
          {product.old_price && <span className="text-ardoise/40 line-through text-sm">{eur(product.old_price)}</span>}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
